import { Injectable } from '@angular/core';
@Injectable({
    providedIn: 'root'
})
export class MobileAppService {
    isTest = false;
    constructor() { }

    private shouldStayOnCurrentDomain(): boolean {
        const host = window?.location?.hostname || '';
        return host === 'localhost' || host === '127.0.0.1' || host.includes('azurewebsites.net');
    }

    private getCurrentOriginURL(): string {
        return window.location.origin + '/';
    }

    getURL() {
        if (this.isTest) {
            return 'https://flinkit-app-v3-swap.azurewebsites.net/';
        } else if (this.shouldStayOnCurrentDomain()) {
            return this.getCurrentOriginURL();
        } else{
            return 'https://showcase.flinkit.io/';

        }
    }

    getURLByPartner(partner) {
        if (this.isTest) {
            return 'https://flinkit-app-v3-swap.azurewebsites.net/';
        } else if (this.shouldStayOnCurrentDomain()) {
            return this.getCurrentOriginURL();
        } else if(partner.partnerURL){
            return partner.partnerURL;
        }
         else{
            return 'https://showcase.flinkit.io/';
        }
    }

}